<template>
  <div>
    <dt>{{ label }}</dt>
    <dd v-html="value" style="white-space: normal !important;" />
  </div>
</template>

<script>
export default {
  name: "view-c-protocolo-text-area",
  props: {
    label: String,
    value: String
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/TextArea.vue